<div id="snackbar-container">
  @for (item of notifications(); track item) {
    <div class="snackbar" [class.remove-animation]="item.removeAnimation">
      <app-snackbar
        [type]="item.type"
        [message]="item.message"
        (removeNotification)="removeNotification(item)"></app-snackbar>
    </div>
  }
</div>
